import React, { Component } from "react";

import Api from "../../lib/componentApi";
import { facebookLogin, fbInit } from "../../lib/facebook";
import mixpanel from "../../lib/mixPanel";

import AppErrors from "../Common/AppErrors";
import PhoneInput from "../Common/PhoneInput";

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eyeOff: true,
      errorMessage: null
    };
  }
  componentDidMount() {
    fbInit();
    const popup = document.getElementById("popup-bg");
    const { onCloseLogin } = this.props;
    if (popup) {
      popup.addEventListener("click", () => onCloseLogin(), false);
    }
  }

  facebookLoginHandler = fbResponse => {
    const {
      checkOut,
      updateUser,
      openFacebookForm,
      onCloseForCheckOut,
      pathname
    } = this.props;
    if (fbResponse.status === "connected") {
      window.FB.api("/me", () => {
        const fbAccessToken = fbResponse.authResponse.accessToken;
        Api.post(
          "/api/loginWithFacebook",
          { fbAccessToken },
          (response, errors) => {
            if (errors) {
              if (errors === 503) {
                this.setState(() => {
                  throw errors;
                });
              } else {
                console.log(errors);
              }
            } else if (response.code) {
              if (response.code === 2026) {
                openFacebookForm({ emailRequired: true, fbAccessToken });
              } else if (response.code === 2025) {
                openFacebookForm({ emailRequired: false, fbAccessToken });
              } else {
                mixpanel.people.set({
                  "Connected Facebook": false,
                  Platform: "Web"
                });
                console.log(response, "code-fb-login");
              }
            } else {
              mixpanel.people.set({
                "Connected Facebook": true,
                Platform: "Web"
              });
              if (updateUser) {
                updateUser({ shouldUpdate: true });
              }
              // eslint-disable-next-line
              if (checkOut && __isBrowser__) {
                onCloseForCheckOut("loginSection");
              } else {
                if (pathname && pathname.startsWith("/register")) {
                  window.location.href = "/";
                } else {
                  location.reload(true);
                }
              }
            }
          }
        );
      });
    } else {
      console.log("unLogged!");
    }
  };
  handlePasswordVisibility = event => {
    event.preventDefault();
    const { eyeOff } = this.state;
    this.setState({ eyeOff: !eyeOff });
  };
  onClickClose = () => {
    this.setState({
      errorMessage: null
    });
  };
  onCloseSignup = () => {
    const { onCloseForCheckOut, onCloseSection } = this.props;
    if (onCloseSection) {
      onCloseSection();
    } else if (onCloseForCheckOut) {
      onCloseForCheckOut("loginSection");
    } else {
      window.location.href = "/";
    }
  };
  render() {
    const {
      onChange,
      email,
      password,
      firstName,
      lastName,
      submitPhoneNumber,
      handleSubmit,
      active,
      formErrors,
      showErrors,
      updateUser,
      onCloseLogin
    } = this.props;
    const { eyeOff, errorMessage } = this.state;
    return (
      (errorMessage && (
        <AppErrors message={errorMessage} onClickClose={this.onClickClose} />
      )) || (
        <div>
          <div className="modal-bg" id="popup-bg" />
          <div className="modal">
            <div className="sign-page register-page">
              {/* Header */}
              <div className="head-general with-back">
                <a href="javascript: void(0)" className="back" />
                <h4>SIGN UP</h4>
                <a
                  href="javascript: void(0)"
                  onClick={onCloseLogin}
                  className="close"
                >
                  <i className="icon icon-close" />
                </a>
              </div>
              {/* Header */}

              <div className="modal-body">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="sign-with-facebook">
                      <button
                        onClick={() => facebookLogin(this.facebookLoginHandler)}
                      >
                        <i className="fab fa-facebook-f" /> Sign up with
                        Facebook
                      </button>
                    </div>
                    <form onSubmit={e => handleSubmit(e, updateUser)}>
                      <div
                        className={`form-group ${(showErrors &&
                          formErrors &&
                          formErrors["firstName"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="firstName"
                          className="form-input"
                          value={firstName}
                          type="text"
                          autoCapitalize="none"
                          placeholder="First Name"
                          onChange={e => onChange(e)}
                        />
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["firstName"] &&
                            formErrors["firstName"]) ||
                            ""}
                        </span>
                      </div>

                      <div
                        className={`form-group ${(showErrors &&
                          formErrors &&
                          formErrors["lastName"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="lastName"
                          className="form-input"
                          autoCapitalize="none"
                          value={lastName}
                          type="text"
                          placeholder="Last Name"
                          onChange={e => onChange(e)}
                        />
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["lastName"] &&
                            formErrors["lastName"]) ||
                            ""}
                        </span>
                      </div>
                      <div
                        className={`form-group ${(showErrors &&
                          formErrors &&
                          formErrors["password"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="password"
                          className="form-input"
                          autoCapitalize="none"
                          value={password}
                          type={eyeOff ? "password" : "text"}
                          autoComplete="password"
                          placeholder="Password"
                          onChange={e => onChange(e)}
                        />
                        <i
                          onClick={e => this.handlePasswordVisibility(e)}
                          className={
                            eyeOff ? "icon icon-eye-off" : "icon icon-eye-on"
                          }
                        />
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["password"] &&
                            formErrors["password"]) ||
                            ""}
                        </span>
                      </div>
                      <div
                        className={`form-group ${(showErrors &&
                          formErrors &&
                          formErrors["email"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="email"
                          className="form-input"
                          autoCapitalize="none"
                          autoComplete="email"
                          value={email}
                          type="email"
                          placeholder="Email"
                          onChange={e => onChange(e)}
                        />
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["email"] &&
                            formErrors["email"]) ||
                            ""}
                        </span>
                      </div>
                      <PhoneInput
                        showErrors={showErrors}
                        submitPhoneNumber={submitPhoneNumber}
                      />
                      <p className="small">
                        We use your phone number and e-mail address to send you
                        order details and receipts
                      </p>
                      <div className="login-foot">
                        <div className="pt visible-xs">
                          <p>Already have an account?</p>
                          <a
                            href="javascript: void(0)"
                            onClick={this.onCloseSignup}
                          >
                            Sign in!
                          </a>
                        </div>
                        <p>
                          By signing into your account or joining you agree to
                          our&nbsp;&nbsp;
                          <a href="/terms">Terms and Conditions</a>
                          &nbsp;and&nbsp;
                          <a href="/privacy">Privacy Policy</a>
                        </p>
                      </div>
                      <div className="">
                        <button
                          className={`btn btn-sign register-button fixed-btn ${(active &&
                            "active") ||
                            ""}`}
                          type="submit"
                        >
                          <span>Become a member</span>
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="col-sm-6 hide-xs">
                    <div className="desktop-gray-side">
                      <p>
                        Already have an account?
                        <br />
                        <a
                          href="javascript: void(0)"
                          onClick={() => {
                            this.onCloseSignup();
                          }}
                        >
                          Sign in!
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default SignupForm;
